import { render } from "./Edit_1.vue?vue&type=template&id=337e6a88&scoped=true"
import script from "./Edit_1.vue?vue&type=script&lang=js"
export * from "./Edit_1.vue?vue&type=script&lang=js"

import "./Edit_1.vue?vue&type=style&index=0&id=337e6a88&scoped=true&lang=css"

import exportComponent from "E:\\backup\\Vue\\NK\\Register_studen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337e6a88"]])

export default __exports__